import React from 'react'
import {createBrowserRouter} from 'react-router'
import {Home} from '@/components/screens/home';
import {VlogsDirectory} from "@/components/screens/vlogs/directory";
import {VlogDashboard} from '@/components/screens/vlogs/dashboard';
import * as API from '@/api'
import {VlogManager} from "./screens/vlogs/manager";
import {AppLayout} from "./layouts/app";
import {SignUpScreen} from "./screens/sign_up";
import {SignInScreen} from "./screens/sign_in";
import {UserManagerScreen} from "./screens/users/manager";
import {ScreenLayout} from "./layouts/screen";
import {ReplayDashboard} from "./screens/replays/dashboard";

export const router = createBrowserRouter([
  {
    path: "",
    element: <AppLayout />,
    children: [{
      path: "/",
      element: <Home />,
      loader: async () => API.Replays.nextReplay(),
      root: true
    },
    {
        path: "/vlogs",
        element: <ScreenLayout width="full"><VlogsDirectory /></ScreenLayout>,
        loader: async () => API.Vlogs.index()
      },
      {
        path: "/vlogs/:vlogID",
        element: <VlogDashboard/>,
        loader: async ({params}) => {
          const vlog = await API.Vlogs.show(params.vlogID)
          const transcript = await API.Vlogs.transcript(params.vlogID)

          return {vlog, transcript}
        }
      },
      {
        path: "/vlogs/:vlogID/edit",
        element: <ScreenLayout><VlogManager /></ScreenLayout>,
        loader: async ({ params }) => {
          const vlog = await API.Vlogs.show(params.vlogID)
          const transcript = await API.Vlogs.transcript(params.vlogID)

          return { vlog, transcript }
        }
      },
      {
        path: '/my/user',
        element: <ScreenLayout><UserManagerScreen/></ScreenLayout>,
        loader: async ({ params }) => {
          const credentials = await API.My.Credentials.index()

          return { credentials }
        }
      },
      {
        path: "/replays/:replayID",
        element: <ReplayDashboard/>,
        loader: async ({params}) => {
          const replay = await API.Replays.show(params.replayID)
          const transcript = await API.Vlogs.transcript(replay.vlog_id)

          return {replay, transcript}
        }
      },
      {
        path: '/sign-in',
        element: <ScreenLayout><SignInScreen /></ScreenLayout>
      },
      {
        path: '/sign-up',
        element: <ScreenLayout><SignUpScreen /></ScreenLayout>
      }
    ]
  }
]);
